import { useState } from 'react';
import { TestResults } from '@elementary/common-ui/pages';
import { DEFAULT_DAYS_BACK } from '@elementary/common-ui/constants';
import AlertDetails from '@/shared/components/AlertDetails';
import useReport from '@/shared/hooks/useReport';
import useReportTests from '../hooks/useReportTests';

const TestResultsPage = () => {
  const [search, setSearch] = useState('');
  const { reportData } = useReport();

  const data = useReportTests({ reportData });

  return (
    <TestResults
      {...data}
      daysBack={reportData?.days_back || DEFAULT_DAYS_BACK}
      invocationData={reportData?.invocation}
      search={search}
      onSearch={setSearch}
      expandedRowRenderer={(rowData) =>
        rowData.testResult ? (
          <AlertDetails rowData={rowData.testResult} showWidgetButtons />
        ) : null
      }
    />
  );
};

export default TestResultsPage;
